<div class="container" *ngIf="!showImport && !showUpdateImport">
  <div class="col-md-12 mb-3 empl-tptxt">
    <h3>Employee Summary</h3>
  </div>
  <div class="col-md-12 justify-content-end d-flex gap-3 mb-2">
    <a>
      <button type="button" class="btn-actvtytp" (click)="showImport = !showImport">BULK IMPORT</button>
    </a>
    <a>
      <button type="button" class="btn-actvtytp" (click)="showUpdateImport = !showUpdateImport">BULK Update EE</button>
    </a>
  </div>
  <div class="col-12">
    <div class="row">
      <app-summary-data-table [options]="summaryOptions" [data]="summaryData"></app-summary-data-table>
    </div>
  </div>
  <br />
</div>
<div *ngIf="(showImport || showUpdateImport) && importValidator">
  <app-bulk-import
    [showNavBar]="false"
    [showLeftMenu]="false"
    [validator]="showImport ? importValidator : updateImportValidator"
    (importClose)="showImport = false; showUpdateImport = false"
    [close]="false"></app-bulk-import>
</div>

<div class="modal" *ngIf="isRehireModalVisible">
  <div class="modal-content" (mousedown)="startDragging($event)" (mouseup)="stopDragging()">
    <div class="header">
      <span class="close" (click)="closeRehireModal()" (keydown)="closeRehireModal()">&times;</span>
    </div>
    <div class="empl-tptxt">
      <h3 class="">Rejoining Details</h3>
      <div class="accordion-body" style="max-height: 400px; overflow-y: auto; overflow-x: auto">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th class="serial-no-column" scope="col">S. No</th>
              <th scope="col">Previous DOJ</th>
              <th scope="col">Previous DOE</th>
              <th scope="col">Old PF Account Number</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="let employeeRehireDetail of currentEmployeeDetails.employeeRehireDetails; let i = index">
              <tr>
                <td class="serial-no-column">
                  {{ i + 1 }}
                </td>
                <td>
                  {{ employeeRehireDetail.previousDoj | date : 'dd-MM-yyyy' }}
                </td>
                <td>
                  {{ employeeRehireDetail.previousDol | date : 'dd-MM-yyyy' }}
                </td>
                <td>
                  {{ currentEmployeeDetails?.employeeStatutoryDetails?.pfNumber }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
